import { useSelector } from 'react-redux';

import { selectSelectedDocuments } from '../services/selectors';

export const useSelectedDocuments = () => useSelector(selectSelectedDocuments);
